<template>
  <v-dialog v-model="show" :max-width="700" :fullscreen="$vuetify.breakpoint.xsOnly" transition="dialog-bottom-transition" scrollable>
    <v-card :class="{ 'rounded-xl': !$vuetify.breakpoint.xsOnly }" elevation="10" class="d-flex flex-column">
      <v-card-title class="pa-4 primary white--text d-flex justify-space-between align-center">
        <span class="text-h6 font-weight-bold">Nuevo usuario</span>
        <v-btn icon dark @click="show = false" v-if="$vuetify.breakpoint.xsOnly">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6 bg-app">
        <v-container>
          <v-form ref="addUser">
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="text-subtitle-1 font-weight-bold primary--text">Datos generales</span>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Nombre"
                  :rules="validation()"
                  v-model="name"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  dense
                  label="Apellido"
                  :rules="validation()"
                  v-model="lastName"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  dense
                  label="Teléfono"
                  type="number"
                  :rules="validationPhone()"
                  v-model="phone"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  dense
                  label="Correo"
                  :rules="validationEmail()"
                  v-model="email"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="zones.length != 0">
                <v-autocomplete
                  outlined
                  dense
                  label="Rol"
                  :rules="validation()"
                  v-model="role"
                  :items="roles"
                  item-text="text"
                  return-object
                  class="white rounded-lg"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="
                  role && (role.value == 'ADVISOR' || role.value == 'MANAGER')
                "
              >
                <v-autocomplete
                  outlined
                  dense
                  label="Zona"
                  v-model="zone"
                  :items="zones"
                  item-text="name"
                  return-object
                  class="white rounded-lg"
                ></v-autocomplete>
              </v-col>
              <!-- <v-col
                cols="12"
                xl="6"
                lg="6"
                v-if="role && role.value == 'SAMPLER_SOLENA'"
              >
                <v-autocomplete
                  outlined
                  dense
                  label="Asesor externo en zona(s)"
                  :items="zones"
                  item-text="name"
                  v-model="asesorExternalZones"
                  multiple
                  chips
                ></v-autocomplete>
              </v-col> -->
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Contraseña"
                  :rules="validationPassword()"
                  v-model="password"
                  prepend-inner-icon="mdi-form-textbox-password"
                  class="white rounded-lg"
                  append-icon="mdi-auto-fix"
                  @click:append="generatePassword"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pt-6">
                <span class="text-subtitle-1 font-weight-bold primary--text">Dirección (opcional)</span>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Codigo postal"
                  v-model="address.zipCode"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  dense
                  label="Calle"
                  v-model="address.street"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  dense
                  label="N. exterior"
                  v-model="address.interiorNumber"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  dense
                  label="N. interior (opcional)"
                  v-model="address.interiorNumber"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  dense
                  label="Colonia"
                  v-model="address.suburb"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  dense
                  label="Ciudad"
                  v-model="address.city"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  dense
                  label="Estado"
                  v-model="address.state"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4 bg-white">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          text
          @click="show = false"
          :disabled="isLoading"
          class="px-4"
        >
          Cancelar
        </v-btn>
        <v-btn color="primary" rounded @click="add" :loading="isLoading" elevation="0" class="px-8">
          Crear
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
//validation
import {
  requiredValidation,
  requiredValidationPassword,
  phoneValidation,
  emailValidation,
} from "@/helpers/validations.js";
export default {
  data: () => ({
    isLoading: false,
    role: null,
    roles: [
      {
        text: "Asesor Solena",
        value: "SAMPLER_SOLENA",
      },
      {
        text: "Asesor",
        value: "ADVISOR",
      },
      {
        text: "Gerente zona",
        value: "MANAGER",
      },
      {
        text: "Gerente distribuidor",
        value: "GEN_MANAGER",
      },
    ],
    email: null,
    password: null,
    lastName: null,
    name: null,
    phone: null,
    address: {
      city: "",
      exteroirNumber: "",
      interiorNumber: "",
      state: "",
      street: "",
      suburb: "",
      zipCode: "",
    },
    zone: null,
    zones: [],
    // asesorExternalZones: null,
    emailValidations: emailValidation(),
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("user", ["distributorSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("user", ["addUser", "getEmailVerification"]),
    ...mapActions("zone", ["getZonesByDistributor"]),
    validation(name) {
      return requiredValidation(name);
    },
    validationPassword(name) {
      return requiredValidationPassword(name);
    },
    validationPhone(name) {
      return phoneValidation(name);
    },
    validationEmail(name) {
      return this.emailValidations;
    },
    async add() {
      try {
        if (this.$refs.addUser.validate()) {
          this.isLoading = true;
          let payload = {
            role: this.role ? this.role.value : "SELLER",
            email: this.email,
            password: this.password,
            lastName: this.lastName,
            name: this.name,
            phone: this.phone,
            address: this.address,
            sellerType: true,
            distributionOrganizationId: this.distributorSelected._id,
            isExpire: false,
            clientList: [],
          };
          if (this.zone) {
            payload.zone = this.zone._id;
          }
          let response = await this.addUser(payload);
          if (!response) throw response;
          this.$emit("fetchData");
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Usuario creado",
            timeout: 5000,
          });
          this.show = false;
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al crear usuario",
          timeout: 5000,
        });
      }
      this.isLoading = false;
    },
    async getZones() {
      try {
        let payload = {
          distributorId: this.distributorSelected._id,
        };
        let response = await this.getZonesByDistributor(payload);
        if (!response) throw response;
        this.zones = response.zones;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar zonas",
          timeout: 5000,
        });
      }
    },
    generatePassword() {
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      const passwordLength = 13;
      let password = "";

      for (let i = 0; i < passwordLength; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        password += characters.charAt(randomIndex);
      }
      this.password = password;
    },
  },
  async created() {
    await this.getZones();
  },
  watch: {
    async email(value) {
      if (!value) return;
      // verify if email already exist in other user
      try {
        let response = await this.getEmailVerification({ email: value });
        if (!response) throw response;
        console.log(response.exist);
        if (response.exist) {
          this.emailValidations = [];
          this.emailValidations.push(...emailValidation());
          this.emailValidations.push((v) => `El correo ya esta registrado`);
        } else {
          this.emailValidations = [];
          this.emailValidations.push(...emailValidation());
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
